import React from 'react'
import { CardBody, CardLink } from "reactstrap";

//URL
import configData from "../../../config.json";
import { formatoFecha, IPropsDashboardIndividual } from './Dashboard_Individual_Admin';

export const function_obtener_regimen_segun_id = (id_regimen: number): string => {
    const parseo_regimen_id = [
        { id_regimen: 7, nombre: "LOSEP" },
        { id_regimen: 8, nombre: "LOES" },
        { id_regimen: 9, nombre: "CÓDIGO DE TRABAJO" },
        { id_regimen: 0, nombre: "CIVIL" },
    ]

    var valor = "";

    parseo_regimen_id.map((value, index) => {
        if (id_regimen === value.id_regimen)
            valor = value.nombre
    })

    return valor;
}




export type Data_Dashboard_Formulario107 =
    {
        anio: number,
        tipoFormulario: string,
        refArchivo: string,
        idArchivo: string,
    }

export type Data_Dashboard_Gastos_Personales =
    {
        periodoFiscal: number,
        idArchivo: string,
    }

export type Data_Dashboard_Certificado =
    {
        fechahora: Date,
        refArchivo: string,
        idArchivo: string,
        idcertificadoth: number,
        nombreCertificado:string
    }

export type Data_Dashboard_Contrato =
    {
        fechainiciocontrato: Date,
        refarchivo: string,
        idArchivo: string,
        contrato: string,
        idregimenlaboral: number
    }
export type Data_Dashboard_Descargas =
    {
        formulario107?: Data_Dashboard_Formulario107,
        gastos_personales?: Data_Dashboard_Gastos_Personales,
        certificado: Data_Dashboard_Certificado[],
        contrato: Array<Data_Dashboard_Contrato>,
        idregimenlaboral: number,
    }



type ArgumentDownloadFile = Data_Dashboard_Formulario107 | Data_Dashboard_Gastos_Personales | Data_Dashboard_Certificado | Data_Dashboard_Contrato


const Card_Descargas: React.FC<IPropsDashboardIndividual> = (props: IPropsDashboardIndividual) => {

    var datos_formulario: Data_Dashboard_Descargas = props.datos ? props.datos : null;





    const function_is_Formulario107 = (datos: ArgumentDownloadFile): datos is Data_Dashboard_Formulario107 => {
        return (datos as Data_Dashboard_Formulario107).anio !== undefined;
    }

    const function_is_Certificado = (datos: ArgumentDownloadFile): datos is Data_Dashboard_Certificado => {
        return (datos as Data_Dashboard_Certificado).idcertificadoth !== undefined;
    }

    const function_is_Contrato = (datos: ArgumentDownloadFile): datos is Data_Dashboard_Contrato => {
        return (datos as Data_Dashboard_Contrato).fechainiciocontrato !== undefined;
    }





    const function_download_file = (e: any, datos: ArgumentDownloadFile | undefined) => {

        e.preventDefault();

        if (datos !== undefined) {
            var url_archivo: string = `${configData.SERVER_URL}DatosDashboard/Formulario107/refArchivo/${datos.idArchivo}`
            var name = "ARCHIVO";

            if (function_is_Formulario107(datos)) {
                const usar: Data_Dashboard_Formulario107 = datos;
                name = "Formulario 107 - " + usar.anio
            }
            else if (function_is_Certificado(datos)) {
                url_archivo = `${configData.SERVER_URL}DatosDashboard/Certificado/refArchivo/${datos.idArchivo}`
                const usar: Data_Dashboard_Certificado = datos;
                name = "Certificado- "
            }
            else if (function_is_Contrato(datos)) {
                url_archivo = `${configData.SERVER_URL}DatosDashboard/Certificado/refArchivo/${datos.idArchivo}`
                const usar: Data_Dashboard_Contrato = datos;
                var cabecera_nombre_doc = ""
                if (usar.contrato === "NOMBRAMIENTO") cabecera_nombre_doc = "Accion_del_Personal "
                else cabecera_nombre_doc = "Contrato "
                name = cabecera_nombre_doc + function_obtener_regimen_segun_id(usar.idregimenlaboral)
            }
            else {
                const usar: Data_Dashboard_Gastos_Personales = datos;
                url_archivo = `${configData.SERVER_URL}DatosDashboard/Contrato/refArchivo/${datos.idArchivo}`
                name = "Gastos Personales - " + usar.periodoFiscal
            }


            fetch(url_archivo)
                .then(response => {
                    response.blob().then(blob => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = name;
                        a.click();
                    });
                });
        }


    };





    // if(!function_HayInfoDisponible(datos_ingresos_mensuales)){
    //     return(
    //         <CardBody>
    //             <div>No hay información de ingresos mensuales disponible</div>
    //         </CardBody>
    //     )
    // }
    var certificado: Data_Dashboard_Certificado[] = []
    var contrato: Data_Dashboard_Contrato[] = []
    if (datos_formulario !== null) {
        var { formulario107, gastos_personales, certificado, contrato } = datos_formulario

    }

    if (!formulario107 && !gastos_personales && !certificado && !contrato) {
        return (
            <CardBody>
                <div>No hay información disponible para descargar</div>
            </CardBody>
        )
    }


    if (datos_formulario === null) {
        return (
            <CardBody>
                <div>Error al intentar obtener contenido de Descargas</div>
            </CardBody>
        )
    }

    var code_status: number | undefined = props.status_response;

    if (code_status && code_status === 500) {
        return (
            <CardBody>
                <div>Ha ocurrido un error al tratar de obtener información </div>
            </CardBody>
        )
    } else if (code_status && code_status === 0) {
        return (
            <CardBody>
                <div>No fue posible contactarse con el servidor </div>
            </CardBody>
        )
    }

    return (
        <CardBody>

            <div className="container_cb_form107">
                {formulario107 &&
                    <p >
                        {`Formulario ${formulario107.tipoFormulario.split("-")[1]} ${formulario107.anio} `}
                        <CardLink className="ml-2" onClick={(e: any) => function_download_file(e, formulario107)} href="#"><i className="fas fa-download" aria-hidden="true"></i></CardLink>
                    </p>
                }

                {gastos_personales &&
                    <p >
                        {`Gastos Personales ${gastos_personales.periodoFiscal} `}
                        <CardLink className="ml-2" onClick={(e: any) => function_download_file(e, gastos_personales)} href="#"><i className="fas fa-download" aria-hidden="true"></i></CardLink>
                    </p>
                }
                {certificado.length > 0 &&
                    certificado.map((cert, index) => {
                        return (
                            <p key={cert.idcertificadoth +"certificado"}>
                                {`${cert.nombreCertificado} emitido ${formatoFecha(cert.fechahora.toString())} `}
                                <CardLink className="ml-2" onClick={(e: any) => function_download_file(e, cert)} href="#"><i className="fas fa-download" aria-hidden="true"></i></CardLink>
                            </p>
                        )
                    })

                }
                {contrato.length != 0 &&
                    contrato.map((archivo_contrato, index) => {
                        var cabecera_nombre_doc = ""
                        if (archivo_contrato.contrato === "NOMBRAMIENTO") cabecera_nombre_doc = "Acción del Personal "
                        else cabecera_nombre_doc = "Contrato "
                        return (
                            <p key={archivo_contrato.idArchivo} >
                                {`${cabecera_nombre_doc + function_obtener_regimen_segun_id(archivo_contrato.idregimenlaboral)}`}
                                <CardLink className="ml-2" onClick={(e: any) => function_download_file(e, archivo_contrato)} href="#"><i className="fas fa-download" aria-hidden="true"></i></CardLink>
                            </p>
                        )


                    })

                }



            </div>



        </CardBody>
    )
}

export default Card_Descargas;